export default {
  name: "v-video-side-modal",
  data: function data() {
    return {
      modal: false
    };
  },
  props: {
    videoSideModalUrl: String
  },
  emits: ['modal-shown', 'modal-hidden'],
  methods: {
    show: function show() {
      console.log("VideoSideModal.show() called");
      this.modal = true;
    },
    hide: function hide() {
      console.log("VideoSideModal.hide() called");
      this.modal = false;
    },
    onModalShow: function onModalShow() {
      this.$emit('modal-shown');
      console.log("Video modal opened with URL:", this.videoSideModalUrl);
    },
    onModalHidden: function onModalHidden() {
      this.$emit('modal-hidden');
      console.log("Video modal closed");
    }
  }
};